// extracted by mini-css-extract-plugin
module.exports = {"taskForm":"TaskForm_taskForm__2tpIu","submit":"TaskForm_submit__3Qqi3"};